import React from 'react';
//import { useNavigate } from 'react-router-dom';
import {  useSelector } from "react-redux";
//import { portalActions } from "../../../store/portal-slice";
//import { getLocalStore, setLocalStore } from "helpers/localStoreSrv";
// import whitelabelConfig from "@whitelabel-config";
//import { useUiState } from "helpers/useUiState";
import { useApi } from "helpers/useApi";
// import api from "helpers/api";
export const useVisitIntakeSrv = () => {
    //const { isAppLoading } = useUiState();
    //const dispatch = useDispatch();
    const { api } = useApi();
    const portalSessionMeta = useSelector((state: any) => state.portal.micrositeSession);
    console.log("portalSessionMeta", portalSessionMeta)

    const getProcedure = () => {
        console.log("portalSessionMeta ww", portalSessionMeta)
        return api.get('/api/rewardprocedure')        
    }

    const getVisitList = () => {
        console.log("getVisitList ww", portalSessionMeta)
        return api.get('/api/membervisit/visitintake')        
    }
    
    const submitVisitIntake = (visitIntakeData: any) => {
        console.log("service", visitIntakeData)
        //    let payload=JSON.stringify(portalSessionMeta.urlRef);
        return api.postForm('/api/membervisit/updatevisitintake', visitIntakeData)
    }
    // const restoreMicrositeSession = (micrositeSession: any) => {
    //     console.log(micrositeSession);
    //     dispatch(portalActions.updateMicrositeSession(micrositeSession));
    // }
    return { getProcedure, submitVisitIntake, getVisitList }
    // return {  getMemberAddresses, submitVisitIntake }
}